/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import customStyles from "../../../../../assets/styles/customStyles";
import { CustomForm } from './CustomForm';
import { useParams } from "react-router-dom";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import clsx from "clsx";
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";


const CustomerProductsCreate = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const formRef = useRef('');
    const { values, type } = useParams();
    const [view, setView] = useState(false);
    const decryptedValues = AESDecrypt(values);
    const [showDetails, setShowDetails] = useState(true);
    const classes = customStyles();
    const { history } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('Customer Products', type, history, 'Sales')) {
            loadTask();
        }
        if (type === 'view') {
            setView(true);
        } else {
            setView(false);
        }
    }, [values, type, roleManagement]);

    const loadTask = () => {
        if (values) {
            setShowDetails(false);
            formRef.current.onEdit(decryptedValues);
        }
    }

    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'}
                closeLink={'/sales/setup/customer-products'}
                img={SalesIcon} title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Products', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: type === 'create' ? true : !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomForm
                        ref={formRef}
                        showDetails={type === 'create' ? false : showDetails}
                        loadMore={type === 'create' ? true : !showDetails}
                        view={view}
                        values={decryptedValues}
                        type={type}
                        roleManagement={roleManagement}
                        loadTask={() => loadTask()}
                        classes={classes}
                        dispatch={dispatch}
                        clsx={clsx}
                        history={history}
                        {...props}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default CustomerProductsCreate